import { render, staticRenderFns } from "./call-by-ticket.vue?vue&type=template&id=6a1c356c"
import script from "./call-by-ticket.vue?vue&type=script&lang=ts"
export * from "./call-by-ticket.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports